module.exports = __webpack_public_path__ + "img/hair_color_chestnut.27582a1.svg";